<template>
  <modal @close="closeModal" class="modal-contact" :displayCross="true">
    <ApolloMutation
      :mutation="require('@/graphql/Contact.gql')"
      :variables="{
          name: name,
          email: email,
          message: message,
          profile: profile,
          referer: $route.fullPath
      }"
      @done="done()"
    >
      <template slot-scope="{ mutate, loading, error }">
        <form method="post" @submit.prevent="mutate()">
          <big-title :text="'Envoyez-nous un message'" :hasBlock="true" class="title-contact"/>
          <paragraph class="u-color--text-popin text-contact" :text="'Votre emplacement dans le site sera automatiquement ajouté à votre message afin de faciliter le traitement de votre demande.'" />

            <div class="element-group">
              <label for="name">Prénom et nom <span class="required">*</span></label>
              <input id="name" type="text"  name="name" v-model="name" required>
            </div>

            <div class="element-group">
              <label for="email">Email <span class="required">*</span></label>
              <input id="email" type="email" name="email" v-model="email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" title="Veuillez saisir un email" oninvalid="setCustomValidity('Format de mail incorrect')" oninput="setCustomValidity('')" required>
            </div>

            <div class="element-group">
              <label for="message">Votre message <span class="required">*</span></label>
              <textarea id="message" name="message" v-model="message" required></textarea>
            </div>

            <div class="submit-button">
              <input type="submit" value="Envoyez" :disabled="loading" class="u-bg--blue cta-round">
            </div>
          </form>
          <p v-if="error">An error occured: {{ error }}</p>

        <p class="rgpd u-color-text-popin">En indiquant votre adresse e-mail, et en validant ce formulaire, vous acceptez que nous vous contactions par email pour répondre à votre question ou pour vous communiquer la disponibilité d’une nouvelle recommandation. Vos données sont destinées à la Société Française de Dermatologie. Ces données ne feront pas l'objet d'un autre traitement que celui mentionné. Conformément à la règlementation applicable, vous disposez d’un droit d’accès, de rectification et d’opposition aux informations vous concernant. Pour plus d’informations sur le traitement de vos données, consultez notre politique de confidentialité.
        </p>

      </template>
    </ApolloMutation>
  </modal>
</template>

<script>
  import Modal from "../Granular/Modal";
  import BigTitle from "../../Core/BigTitle";
  import Paragraph from "../../Core/Paragraph";

  export default {
    name: "Modal-contact",
    components: {Paragraph, BigTitle, Modal},
    data () {
      return {
        errors: [],
        name: '',
        email: '',
        message: '',
        profile: ''
      }
    },
    methods: {
      done() {
        this.$emit('close');
        this.name = '';
        this.email = '';
        this.message = '';
        this.profile = ''

      },

      closeModal() {
        this.$emit('close');
      },

      mutate() {},
    },

    mounted() {
      if (this.$cookies.isKey('profile')) {
        this.profile = this.$cookies.get('profile')
      }
      else {
        this.profile = ''
      }
    }
  }
</script>

<style lang="scss">

  .modal-contact {

    .title-contact {
      @include mq($until: SM) {
        font-size: rem(20px);
        line-height: rem(24px);
      }
    }

    .separator {
      margin-bottom: rem(15px);
      padding-top: rem(15px);
    }

    .text-contact {
      padding-top: rem(15px);

      @include mq($until: SM) {
        font-size: rem(12px);
        line-height: rem(18px);
        padding-top: 0;
      }
    }

    .form-error {
      color: color(red);
      line-height: rem(24px);
      font-size: rem(14px);

      ul {
        padding: 0;

        li {
          list-style-type: none;
        }
      }
    }

    .element-group {
      display: flex;
      flex-direction: column;
      justify-content: left;
      margin-top: rem(15px);

      label {
        font-size: rem(14px);
        line-height: rem(24px);
        padding-bottom: rem(5px);

        .required {
          color: color(red);
        }
      }

      input, textarea {
        border: 1px solid color(border);
        border-radius: 3px;
        background-color: color(grey);
        min-height: rem(40px);
        width: 100%;

        @include mq($until: MD) {
          min-height: rem(30px);
        }
      }

      textarea {
        min-width: 100%;
        min-height: rem(80px);

        @include mq($until: MD) {
          min-height: rem(60px);
        }
      }
    }

    .submit-button {
      margin: rem(15px) 0 rem(20px);

      .cta-round {
        padding: rem(15px) rem(50px);

        &:hover, &:focus {
          background-color: color(blue-hover);
        }
      }
    }
    .rgpd {
      font-size: rem(11px);
      line-height: rem(16px);
      margin: 0;

      @include mq($until: MD) {
        font-size: rem(10px);
        line-height: rem(15px);
      }
    }
  }

</style>